import React, { useState, useRef } from 'react';
import './BottomSheet.css';

const BottomSheetVar = ({ initialPosition = 65, header, content, peekOffset = 0 }) => {
  const [position, setPosition] = useState(initialPosition);
  const [isOpen, setIsOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const sheetRef = useRef(null);
  const sheetContentRef = useRef(null);
  const startY = useRef(0);

  const handleDragStart = (e) => {
    setIsDragging(true);
    startY.current = e.touches ? e.touches[0].clientY : e.clientY;
  };

  const handleDragging = (e) => {
    if (!isDragging) return;
    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    const delta = currentY - startY.current;
    setPosition((prev) => Math.max(0, prev + delta));
    startY.current = currentY;
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (isOpen) {
      setIsOpen(false);
      setPosition(initialPosition);
      sheetContentRef.current?.scrollTo(0, 0);
      return;
    }
    setIsOpen(true);
    setPosition(0);
  };
  const finalPosition = isOpen ? 0 : Math.max(0, initialPosition - peekOffset);

  return (
    <div
      ref={sheetRef}
      className={`bottom-sheet px-3 ${isOpen ? 'open' : ''}`}
      style={{ transform: `translateY(${finalPosition}px)` }}
    >
      <div
        className='sheet-header'
        onMouseDown={handleDragStart}
        onMouseMove={handleDragging}
        onMouseUp={handleDragEnd}
        onTouchStart={handleDragStart}
        onTouchMove={handleDragging}
        onTouchEnd={handleDragEnd}
      >
        <div className='drag-handle'></div>
        {header}
      </div>
      <div className='sheet-content' ref={sheetContentRef}>
        {content}
      </div>
    </div>
  );
};

export default BottomSheetVar;
